
const sortSublinks = (item) => {
  if (item.sublinks?.length) {
    item.sublinks?.sort((a, b) => {
      if (a.sequenceNumber < 0 && b.sequenceNumber >= 0) return 1
      if (a.sequenceNumber >= 0 && b.sequenceNumber < 0) return -1
      return a.sequenceNumber - b.sequenceNumber
    })
  } else {
    delete item.sublinks
  }
}

const processMenuItems = (menu, menuItems) => {
  menu.menuItems.forEach((item) => {
    sortSublinks(item)
    menuItems.push(item)
  })
}

const processMenus = (zone, menuItems) => {
  zone.menus.forEach((menu) => {
    processMenuItems(menu, menuItems)
  })
}

const processLayoutZones = (layout, menuItems) => {
  layout.layoutZones.forEach((zone) => {
    processMenus(zone, menuItems)
  })
}

const processLayouts = (app, menuItems) => {
  app.layouts.forEach((layout) => {
    processLayoutZones(layout, menuItems)
  })
}

export const getAllMenuItems = (content) => {
  const menuItems = []
  content.forEach((app) => {
    processLayouts(app, menuItems)
  })
  return menuItems
}
